import React, {SVGProps} from "react";

interface Props {
    bgcolor?: string;
    className?: string;
}

const HandCoinsIcon = (props: SVGProps<SVGSVGElement> & Props) => {
    return (
        <svg
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
            pointerEvents="none"
            color="red"
            {...props}
        >
            <title>Hånd med penger</title>
            <g fill="none" fillRule="evenodd">
                <circle cx="50" cy="50" r="50" fill={props.bgcolor ?? "#CDE7D8"} />
                <path fill="#B36D14" d="M48 44h4v8h-4zm12-18h4v9h-4z" />
                <path
                    fill="#669DB3"
                    d="M29.521 54.603h-10.24a1.28 1.28 0 00-1.28 1.28v19.2c0 .704.574 1.28 1.28 1.28h10.24c.704 0 1.28-.576 1.28-1.28v-19.2c0-.707-.576-1.28-1.28-1.28"
                />
                <path
                    fill="#F4F4F2"
                    d="M79.066 65.215c-3.005-3.003-5.598-3.84-8.99-2.867l-7.701 2.555c.07.402.105.809.105 1.218 0 1.639-.532 3.182-1.495 4.34-1.124 1.346-2.709 2.06-4.585 2.06H43.6a1.28 1.28 0 010-2.56h12.8c1.106 0 1.987-.384 2.616-1.139.576-.689.904-1.672.904-2.7 0-1.427-.742-3.84-3.52-3.84h-7.68c-.338 0-.663-.134-.904-.374-1.175-1.176-4.746-4.747-10.616-4.747h-3.84a1.28 1.28 0 00-1.28 1.28v14.08c0 .55.353 1.042.876 1.214a350.998 350.998 0 019.628 3.381c4.935 1.795 7.698 2.765 10.16 2.765 2.937 0 5.448-1.38 10.693-4.375 3.472-1.986 8.223-4.702 15.296-8.238.37-.187.625-.535.692-.942.064-.404-.07-.82-.359-1.111"
                />
                <path
                    fill="#FFBD66"
                    d="M60.241 27.723a1.28 1.28 0 012.56 0v5.12c0 .704-.576 1.28-1.28 1.28-.706 0-1.28-.576-1.28-1.28v-5.12zm1.28 11.52c4.941 0 8.96-4.02 8.96-8.96 0-4.944-4.019-8.96-8.96-8.96-4.94 0-8.96 4.016-8.96 8.96 0 4.94 4.02 8.96 8.96 8.96zm-12.8 6.4a1.28 1.28 0 012.56 0v5.12c0 .704-.576 1.28-1.28 1.28-.706 0-1.28-.576-1.28-1.28v-5.12zm1.28 11.52c4.941 0 8.96-4.02 8.96-8.96 0-4.944-4.019-8.96-8.96-8.96-4.94 0-8.96 4.016-8.96 8.96 0 4.94 4.02 8.96 8.96 8.96z"
                />
            </g>
        </svg>
    );
};

export default HandCoinsIcon;
